import { faCaretDown, faCaretRight, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const ShowHideSettingsButton = ({
    showAdvancedOptions,
    setShowAdvancedOptions,
    below
}) => {
    return (
        <button 
            className='g-button small-btn text-only primary-text'
            onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}>
            {
                showAdvancedOptions
                ? 
                <>
                <span className='meta'>Hide Advanced Options</span>
                <FontAwesomeIcon 
                    icon={below ? faCaretUp : faCaretDown} />
                </>
                : 
                <>
                <span className='meta'>Show Advanced Options</span>
                <FontAwesomeIcon 
                    icon={faCaretRight} />
                </>
            } 
        </button>
    )
}

export default ShowHideSettingsButton